module.exports = {
	SPACE_ID: "etjfeqtjdqem",
	TOKEN: "cP1VqAoa75Cz1ZvNLGLNp2qPtNUCsURb_AdsLnQcT2Q",
};
